import axios from "axios";

export const getAllboards = async () => {
  let url = `https://api.trello.com/1/members/me/boards?key=${process.env.REACT_APP_API_KEY}&token=${process.env.REACT_APP_API_TOKEN}`;

  try {
    const resp = await axios.get(url);
    return resp.data;
  } catch (err) {
    console.error(err);
  }
};

export const deleteBord = (id) => {
  let url = `https://api.trello.com/1/boards/${id}?key=${process.env.REACT_APP_API_KEY}&token=${process.env.REACT_APP_API_TOKEN}`;

  axios.delete(url).then((res) => res.data);
};

export const createBord = async (name) => {
  let url = `https://api.trello.com/1/boards/?name=${name}&key=${process.env.REACT_APP_API_KEY}&token=${process.env.REACT_APP_API_TOKEN}`;

  try {
    const resp = await axios.post(url);

    return resp.data;
  } catch (err) {
    console.error(err);
  }
};

export const getListDestails = async (boardID) => {
  let key = process.env.REACT_APP_API_KEY;
  let token = process.env.REACT_APP_API_TOKEN;

  let url = `https://api.trello.com/1/boards/${boardID}/lists?key=${key}&token=${token}`;

  try {
    const resp = await axios.get(url);

    return resp.data;
  } catch (err) {
    console.error(err);
  }
};

export const createList = async (name, id) => {
  let key = process.env.REACT_APP_API_KEY;
  let token = process.env.REACT_APP_API_TOKEN;
  const url = `https://api.trello.com/1/boards/${id}/lists?name=${name}&key=${key}&token=${token}`;

  const resp = await axios.post(url);

  return resp.data;
};

export const deleteList = (listId) => {
  let key = process.env.REACT_APP_API_KEY;
  let token = process.env.REACT_APP_API_TOKEN;

  axios
    .put(
      `https://api.trello.com/1/lists/${listId}/closed?key=${key}&token=${token}&value=true`
    )
    .then((res) => res.data);
};

export const getAllCards = async (listId) => {
  let key = process.env.REACT_APP_API_KEY;
  let token = process.env.REACT_APP_API_TOKEN;

  const url = `https://api.trello.com/1/lists/${listId}/cards?key=${key}&token=${token}`;
  return await axios.get(url).then((res) => res.data);
};

export const createCard = async (listId, CardName) => {
  let key = process.env.REACT_APP_API_KEY;
  let token = process.env.REACT_APP_API_TOKEN;

  const card = await axios.post(
    `https://api.trello.com/1/cards?idList=${listId}&name=${CardName}&key=${key}&token=${token}`
  );

  return card.data;
};

export const deleteCard = (cardId) => {
  let key = process.env.REACT_APP_API_KEY;
  let token = process.env.REACT_APP_API_TOKEN;

  axios
    .delete(
      `https://api.trello.com/1/cards/${cardId}?key=${key}&token=${token}`
    )
    .then((res) => res.data);
};

// export const updateBord = (id, name) => {
//   axios
//     .put(
//       `https://api.trello.com/1/boards/${id}/?name=${name}&key=${process.env.REACT_APP_API_KEY}&token=${process.env.REACT_APP_API_TOKEN}`
//     )
//     .then((response) => response.data);

//   this.setState({ isEditClicked: false });

//   const updatedBordName = this.state.bordData.map((data) => {
//     if (data.id === id) {
//       data.name = name;
//     }

//     return data;
//   });

//   this.setState({ bordData: updatedBordName });
// };
